export const FETCH_SOURCES_REQUEST = 'FETCH_SOURCES_REQUEST';
export const FETCH_SOURCES_START = 'FETCH_SOURCES_START';
export const FETCH_SOURCES_SUCCESS = 'FETCH_SOURCES_SUCCESS';
export const FETCH_SOURCES_FAILED = 'FETCH_SOURCES_FAILED';



// WEBPACK FOOTER //
// ./app/Sources/list/actionTypes.js